// extracted by mini-css-extract-plugin
export default {"container":"F8-z"};